@if (isOpen()) {
  <div
    class="absolute top-12 z-50 w-[420px] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl ltr:right-0 rtl:left-0"
    (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between border-b border-gray-200 px-4 py-3">
      <div class="flex items-center gap-2">
        <h3 class="font-['Inter'] text-base font-semibold text-gray-900">
          <span i18n="@@notificationsDropdownTitle">Notifications</span>
        </h3>
        @if (unreadCount() > 0) {
          <span
            class="flex h-5 w-5 items-center justify-center rounded-full bg-gray-300 font-['Inter'] text-xs font-medium text-gray-700">
            {{ unreadCount() }}
          </span>
        }
      </div>
      <!-- <div class="flex items-center gap-3">
        <button
          (click)="onMarkAllRead()"
          class="cursor-pointer font-['Inter'] text-xs font-normal text-gray-500 transition-colors hover:text-gray-700">
          <span i18n="@@notificationsDropdownMarkAllRead">Mark all as read</span>
        </button>
      </div> -->
    </div>

    <div class="max-h-[400px] overflow-y-auto">
      @if (notifications().length == 0) {
        <div class="flex items-center justify-center px-4 py-8">
          <p class="font-['Inter'] text-sm text-gray-500">
            <span i18n="@@notificationsDropdownEmpty">No notifications</span>
          </p>
        </div>
      } @else {
        @for (notification of notifications(); track notification.id) {
          <div
            (click)="onMarkAsRead(notification.id)"
            class="cursor-pointer border-b border-gray-100 px-4 py-3 transition-colors hover:bg-gray-50"
            [class.bg-gray-200]="!notification.isRead">
            <div class="flex items-start justify-between gap-3">
              <div class="flex-1">
                <h4 class="font-['Inter'] text-sm font-semibold text-gray-900">
                  {{ isArabic() ? notification.subjectAr : notification.subjectEn }}
                </h4>
                <p class="mt-1 w-3/4 font-['Inter'] text-[13px] font-normal text-gray-600">
                  {{ isArabic() ? notification.bodyAr : notification.bodyEn }}
                </p>
              </div>
            </div>
            <p class="mt-2 text-right font-['Inter'] text-[14px] font-normal whitespace-nowrap text-gray-500">
              {{ notification.createdOn }}
            </p>
          </div>
        }
      }
    </div>

    <div class="flex justify-end border-t border-gray-200 px-4 py-3">
      <a
        routerLink="/admin/notifications"
        (click)="onViewAll()"
        class="text-primary hover-text-primary-hover w-fit font-['Inter'] text-sm font-medium transition-colors">
        <span i18n="@@notificationsDropdownViewAll">View All</span>
      </a>
    </div>
  </div>
}
